import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { coerceBooleanProperty } from '@angular/cdk/coercion';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-timeline-item[title][icon][level]',
    imports: [MatIconModule, CommonModule],
    templateUrl: './timeline-item.component.html',
    styleUrl: './timeline-item.component.scss'
})
export class TimelineItemComponent {
  @Input() title!: string;
  @Input() icon!: string;
  @Input() deeplink?: string;
  @Input()
  get inverted(): boolean {
    return this._inverted;
  }
  set inverted(inverted: boolean) {
    this._inverted = coerceBooleanProperty(inverted);
  }
  private _inverted = false;

  @Input() expandable?: boolean;
  @Input() level!: 'info' | 'success' | 'fail' | 'default' | 'status' | 'end';

  @Input() expanded = false;
  @Output() expandedChange = new EventEmitter<boolean>();

  constructor(
    private readonly router: Router,
    private cdr: ChangeDetectorRef
  ) {}

  async handleClick() {
    if (this.deeplink) {
      await this.router.navigateByUrl(this.deeplink);
    } else if (this.expandable) {
      this.expanded = !this.expanded;
      this.expandedChange.emit(this.expanded);
    }
  }
}
